import utils from '@eitje/utils'
import ContractPart from './active_record/contract_part'

class WorkSchedule extends ContractPart {
	static tableName = 'workSchedules'
	static sort = {field: 'start_date', direction: 'desc'}

	formattedHours = () => {
		return utils.minutesToString(this.total_mins)
	}
}

export default WorkSchedule
